<app-breadcrumbs></app-breadcrumbs>
<div [cfaLoading]="isLoading">
  <mat-form-field id="filter-field">
    <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event.target.value)" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field>
</div>
<div id="table-wrapper">
  <table mat-table matSort #chainAuditTable [dataSource]="auditDataSource" class="chain-audit-table mat-elevation-z8">
    <ng-container matColumnDef="storeNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
      <td mat-cell *matCellDef="let location" class="store-number-cell"
        [routerLink]="['/automation/site-audit']" [queryParams]="{storeNumber:location.storeNumber}">
        {{location.storeNumber}}
      </td>
    </ng-container>
    <ng-container matColumnDef="firmware">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Firmware </th>
      <td mat-cell *matCellDef="let location">
        @for (firmware of location.firmware; track firmware) {
          <span>
            <mat-icon matTooltip="device: {{firmware.device}}&#13;reason: {{firmware.reason}}"
              [matTooltipClass]="'my-tooltip'" class="out-of-spec-icon">
              highlight_off
            </mat-icon>
          </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="model">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Model </th>
      <td mat-cell *matCellDef="let location">
        @for (model of location.model; track model) {
          <span>
            <mat-icon matTooltip="device: {{model.device}}&#13;reason: {{model.reason}}"
              [matTooltipClass]="'my-tooltip'" class="out-of-spec-icon">
              highlight_off
            </mat-icon>
          </span>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="auditDisplayColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: auditDisplayColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
</div>